import { IonButton, IonIcon, IonRouterLink, IonText } from '@ionic/react';
import React from 'react';

import { ButtonContainer, Spacer } from '@/components/common';
import { RequestSummary } from '@/components/summary';
import { useLanguage } from '@/contexts/LanguageContext';
import { useScheduleFlow } from '@/contexts/ScheduleFlowContext';
import { ROUTES } from '@/utils/routes';
import { arrowForwardCircleOutline } from 'ionicons/icons';

import './Confirmation.css';

const Confirmation: React.FC = () => {
  const { t } = useLanguage();
  const {
    clinic,
    selectedDentist: dentist,
    patient,
    request,
    durationInMinutes,
    confirmRequest: onConfirm,
    reset: onReset
  } = useScheduleFlow();

  const copy = {
    subHeader: t('schedule.confirmation.subHeader'),
    header: (
      <>
        {t('schedule.confirmation.header.confirm')}{' '}
        <IonText color="primary">
          {t('schedule.confirmation.header.appointment')}
        </IonText>{' '}
        {t('schedule.confirmation.header.details')}
      </>
    ),
    message: (
      <>
        {t('schedule.confirmation.message.review')}{' '}
        <i>{t('schedule.confirmation.message.requestAppointment')}</i>{' '}
        {t('schedule.confirmation.message.proceed')}
      </>
    ),
    buttonText: t('schedule.confirmation.buttonText'),
    startOverPrompt: t('schedule.confirmation.startOverPrompt'),
    startOverText: t('schedule.confirmation.startOverText'),
    agreementPrefix: t('schedule.confirmation.agreementPrefix'),
    termsText: t('schedule.confirmation.termsText'),
    andText: t('schedule.confirmation.andText'),
    privacyText: t('schedule.confirmation.privacyText')
  };

  return (
    <div className="confirmation">
      <Spacer top={8} bottom={24}>
        <h4 className="confirmation__sub-header">{copy.subHeader}</h4>
        <h1 className="confirmation__header">{copy.header}</h1>
        <p className="confirmation__message">{copy.message}</p>
      </Spacer>
      <RequestSummary
        clinic={clinic}
        dentist={dentist}
        patient={patient}
        request={request}
        showStatus={false}
        durationInMinutes={durationInMinutes}
      />
      <Spacer top={16} bottom={172}>
        <div className="confirmation__start-over">
          <p>{copy.startOverPrompt}</p>
          <IonRouterLink onClick={onReset}>{copy.startOverText}</IonRouterLink>
        </div>
      </Spacer>
      <ButtonContainer translucent={false}>
        <IonButton
          className="confirmation__next-button"
          onClick={onConfirm}
          expand="block"
          fill="solid"
          size="default"
          color="primary"
          strong
        >
          <IonIcon slot="start" icon={arrowForwardCircleOutline}></IonIcon>
          {copy.buttonText}
        </IonButton>
        <p className="confirmation__note">
          {copy.agreementPrefix}{' '}
          <IonRouterLink routerLink={ROUTES.TERMS_OF_SERVICE} target="_blank">
            {copy.termsText}
          </IonRouterLink>{' '}
          {copy.andText}{' '}
          <IonRouterLink routerLink={ROUTES.PRIVACY_POLICY} target="_blank">
            {copy.privacyText}
          </IonRouterLink>
          .
        </p>
      </ButtonContainer>
    </div>
  );
};

export default Confirmation;
